import {
    getTestId,
    RouteStore
} from "../../other/navigationAndRouting/RouteStore";
import styled from "@emotion/styled";
import { level10 } from "../../other/theme/opacities";
import { IRoute } from "../../other/navigationAndRouting/routes";
import { useSingleton } from "../../other/injection";
import { observer } from "mobx-react-lite";
import { Link } from "@/other/navigationAndRouting/Link";

interface IProps {
    routes: IRoute[];
    testId: string;
}

export const BigRouteList = observer(({ routes, testId }: IProps) => {
    const routeStore = useSingleton(RouteStore);

    return (
        <div className="mx-auto max-w-7xl p-3">
            <div className="space-y-4">
                <div className="mb-6 flex items-center justify-between">
                    <div>
                        <h3
                            className={`mb-1 text-2xl font-bold text-slate-900`}
                        >
                            Menu
                        </h3>
                        <p className={`text-sm text-slate-600`}>
                            Navigate to your desired page
                        </p>
                    </div>
                </div>
                <Container data-testid={testId}>
                    {routes.map((x, i) => {
                        return (
                            x.path && (
                                <Link
                                    key={i}
                                    to={x.path}
                                    data-testid={getTestId(x)}
                                >
                                    <Item isFirst={i === 0}>
                                        <Title>
                                            {routeStore.getRouteTitle(x)}
                                        </Title>
                                        {x.description !== undefined && (
                                            <Description>
                                                {routeStore.getRouteDescription(
                                                    x
                                                )}
                                            </Description>
                                        )}
                                    </Item>
                                </Link>
                            )
                        );
                    })}
                </Container>
            </div>
        </div>
    );
});

const Container = styled("div")(props => ({
    "> a": {
        textDecoration: "none",
        color: props.theme.foregroundTitle
    }
}));

const Item = styled("div")<{ isFirst: boolean }>(props => {
    const border = `solid 1px ${props.theme.brandHighlight}`;
    return {
        width: 430,
        minHeight: 66,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        paddingLeft: 10,
        borderTop: props.isFirst ? border : undefined,
        borderBottom: border,
        borderRadius: 1,
        cursor: "pointer",
        "&:hover": {
            backgroundColor: `${props.theme.foreground}${level10}`
        }
    };
});
const Title = styled("div")(props => ({
    marginBottom: 2,
    fontSize: props.theme.fontSizes.medium
}));
const Description = styled("div")(props => ({
    fontSize: props.theme.fontSizes.tiny
}));
